<template>
  <div>
  <h2>{{ title }}</h2>
  <loading :active.sync="isLoading" :is-full-page="true"></loading>
  <template>
    <v-system-bar class="branch-data">
      <v-spacer></v-spacer>
      <div v-on:keypress.enter.prevent="getAboutTable(1)">
        <input-search
          :model="search" @update="searchInput"/>
      </div>
      <circle-button
        v-if="permissionAbout && permissionAbout.permission_id === permission.readWrite"
        @click.native="createAbout" />
    </v-system-bar>
  </template>
  <template>
    <v-simple-table class="branch-data">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center" v-for="header in headers" :key="header.id">
            {{ header.text }}
            <template v-if="header.icon">
              <a @click="sortDataTable">
                <v-icon class="fas fa-caret-down"
                        v-if="sort_order == 'desc'"
                        style="font-size: 12px"></v-icon>
                <v-icon class="fas fa-caret-up"
                        v-if="sort_order == 'asc'"
                        style="font-size: 12px"></v-icon>
              </a>
            </template>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(data, index) in dataTable" :key="data.id">
          <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
          <td>{{ data.branch ? data.branch.branch_name_th : "" }}</td>
          <td>{{ data.name_th }}</td>
          <td>{{ data.updated_at | moment("DD-MM-YYYY") }}</td>
          <td>{{ data.orders }}</td>
          <td>
            <a @click="showAboutData(data.id)">
              <icon-pencil />
            </a>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>

  </div>
</template>

<script>
import InputSearch from "../../components/Input/InputSearch";
import CircleButton from "../../components/Button/CircleButton";
import IconPencil from "../../components/Icon/icon-pencil";
import Paginate from "../../components/Layout/Paginate";
import {permissionAbout, role} from "../../util/Permission";
import Loading from 'vue-loading-overlay';
import Swal from 'sweetalert';
export default {
  name: "AboutTable",
  components: {Paginate, IconPencil, CircleButton, InputSearch, Loading },
  computed:{
    permissionAbout
  },
  data() {
    return {
      title: "About",
      isLoading: false,
      headers: [
        { id: 1, text: "No." ,icon : null},
        { id: 2, text: "Branch" ,icon : null},
        { id: 3, text: "Name" ,icon : null},
        { id: 4, text: "Update date" ,icon : null},
        { id: 5, text: "Order" ,icon : true},
        { id: 6, text: "Edit" ,icon : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission : null,
      search : '',
      sort_order : 'desc',
    };
  },
  created() {
    this.permission = role;
    this.getAboutTable(1);
  },
  methods: {
    getAboutTable(page) {
      this.isLoading = true;
      this.$store.dispatch("About/getAbout", {
        page,
        search : this.search,
        sort_order : this.sort_order,
      }).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getAboutTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    goToAboutEdit() {
      this.$router.push("/about/edit");
    },
    showAboutData(id) {
      this.isLoading = true;
      this.$store.dispatch("About/showAbout", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("About/setFormAbout", res.result).then(() => {
            this.goToAboutEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    createAbout() {
      this.$store.dispatch("About/clearFormData").then(() => {
        this.goToAboutEdit();
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(){
      this.sort_order = this.sort_order == 'desc' ? 'asc' : 'desc';
      this.getAboutTable(1);
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/table.css";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
